import { Container, Link, Stack, Text } from "basis";
import { Layout } from "../../Layout/Layout";

// TODO: manage this with app wide contact info
const phoneNumber = "1300 363 269";

function FatalError({ params = {} }) {
  const { error: Error } = params;

  return (
    <Layout>
      <Layout.Main>
        {Error && <Error />}
        <Stack gap="6">
          <Container>
            <Text color="primary.blue.t100">
              Call us on <strong>{phoneNumber}</strong>
            </Text>
            <Text textStyle="body2">Mon - Fri: 8am-9pm</Text>
            <Text textStyle="body2">Weekends: 8:30am-8pm (AEST)</Text>
          </Container>
          <Link
            appearance="secondary-button"
            variant="blue-button"
            href={`tel:${phoneNumber.replace(/\s/g, "")}`}
            newTab
          >
            Call us
          </Link>
        </Stack>
      </Layout.Main>
    </Layout>
  );
}

export { FatalError };
